import React from "react";
import PropTypes from "prop-types";
import CountryDropdown from "./CountryDropdown";
import TypeDropdown from "./TypeDropdown";
import ResetButton from "./ResetButton";
import { renderCountryOptions } from "../App";

const TopSelector = ({
  countryOptions,
  onCountryChange,
  onTypeChange,
  selectedCountryCode,
  selectedType,
  onReset
}) => (
  <div className="main-dropdown-container">
    <div className="select-container">
      <span className="select-label country">Choose a country</span>
      <CountryDropdown
        onChange={onCountryChange}
        options={renderCountryOptions(countryOptions)}
        placeholder="Select country"
        selectedCountryCode={selectedCountryCode}
      />
    </div>
    <div className="select-container">
      <span className="select-label type">View map by</span>
      <TypeDropdown
        onChange={e => onTypeChange(e)}
        selectedType={selectedType}
      />
    </div>
    <ResetButton onReset={onReset} />
  </div>
);

TopSelector.propTypes = {
  countryOptions: PropTypes.arrayOf(PropTypes.shape({
    country_id: PropTypes.string.isRequired,
    country_name: PropTypes.string.isRequired,
  })),
  onCountryChange: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  selectedCountryCode: PropTypes.string.isRequired,
  selectedType: PropTypes.string.isRequired,
};

export default TopSelector;
